import React from "react"
import { StaticQuery, graphql } from "gatsby"
import Img from "gatsby-image"

const Image = () => (
  <StaticQuery
    query={graphql`
      query {
        file(relativePath: { regex: "/step4.png/" }) {
          childImageSharp {
            fluid(maxWidth: 1400, quality: 100) {
              ...GatsbyImageSharpFluid_withWebp
            }
          }
        }
      }
    `}
    render={data => (
      <Img className="" alt="Step 4: Ingest the trailer DCPs onto your playback server" fluid={data.file.childImageSharp.fluid} />
    )}
  />
)

export default Image
